export const ONBOARDING_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  AWAITING: "awaiting",
  RESUBMITTED: "resubmitted",
  COMPLETED: "completed",
};

/** Review Queue status filter chips — keys match backend `status` values */
export const ONBOARDING_STATUS_FILTERS = [
  { key: "all", label: "All" },
  { key: "Pending", label: "Pending" },
  { key: "In Progress", label: "In Progress" },
  { key: "Awaiting", label: "Awaiting" },
  { key: "Re-submitted", label: "Re-submitted" },
  { key: "Completed", label: "Completed" },
];

/** Action button / chip styles keyed by exact backend status strings */
export const ONBOARDING_STATUS_META = {
  Pending: {
    actionLabel: "Start review",
    className: "rq-status-pending",
  },
  "In Progress": {
    actionLabel: "Continue review",
    className: "rq-status-in-progress",
  },
  Awaiting: {
    actionLabel: "View request",
    className: "rq-status-awaiting",
  },
  "Re-submitted": {
    actionLabel: "Review Updates",
    className: "rq-status-resubmitted",
  },
  Completed: {
    actionLabel: "View request",
    className: "rq-status-completed",
  },
};
